module.exports = __webpack_public_path__ + "assets/img/ic-wel-gift.79da6618.png";